module.exports = __webpack_public_path__ + "static/vid1-6e896de4cdcb86135e61340580789790.mp4";